import React, { useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "../PolicyLayout.css";

const ReturnRefund = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Policy pages पर forceSolid=true दें */}
      <Header forceSolid={true} />

      <div className="policy-page">
        <div className="policy-container">
          <h1 className="policy-title">Return and Refund Policy</h1>

          <h2>30-Day Return Policy</h2>
          <p>
            We offer a 30-day return policy. From the day you receive your item,
            you have 30 days to request a return. To qualify, items must be in
            their original condition, unworn or unused, with tags, and in the
            original packaging. A receipt or proof of purchase is required.
          </p>

          <h2>Return Process</h2>
          <p>
            To initiate a return, please contact us at{" "}
            <strong>support@wonder-theme.com</strong>. Returns should be sent to
            our company only after approval. Upon acceptance of your return, we
            will provide a return shipping label and instructions for sending
            your package. Returns without prior request will not be accepted.
          </p>

          <h2>Damages and Issues</h2>
          <p>
            Upon receiving your order, please inspect it immediately. If you
            find any defects, damages, or receive the wrong item, contact us
            right away so we can address and resolve the issue.
          </p>

          <h2>Non-Returnable Items</h2>
          <p>
            Some items are not eligible for return, such as perishable goods,
            custom products, and personal care items. Returns of hazardous
            materials, flammable liquids, or gases are also not accepted. Please
            contact us if you have questions about your specific item.
          </p>

          <h2>Exceptions</h2>
          <p>Sale items and gift cards are non-returnable.</p>

          <h2>Exchanges</h2>
          <p>
            For an exchange, return the item you have. Once the return is
            accepted, make a separate purchase for the new item.
          </p>

          <h2>EU 14-Day Cooling Off Period</h2>
          <p>
            For orders shipped to the European Union, you have the right to
            cancel or return your order within 14 days for any reason. The item
            must be in its original condition and packaging, with receipt or
            proof of purchase.
          </p>

          <h2>Refunds</h2>
          <p>
            After receiving and inspecting your return, we will inform you if
            the refund is approved. Approved refunds are processed to the
            original payment method within 10 business days. Please allow some
            time for your bank or credit card company to process and post the
            refund.
          </p>

          <h2>Contact</h2>
          <p>
            For any questions regarding returns or refunds, reach out to us at{" "}
            <strong>support@wonder-theme.com</strong>.
          </p>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
};

export default ReturnRefund;